"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var PlayersGridView_1 = __importDefault(require("./PlayersGridView"));
var react_admin_1 = require("react-admin");
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_i18next_1 = require("react-i18next");
var NewPlayerGroupModal_1 = __importDefault(require("./NewPlayerGroupModal"));
var ConnectPlayerModal_1 = __importDefault(require("./ConnectPlayerModal"));
var NewPlayerModal_1 = __importDefault(require("./NewPlayerModal"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var ReactAdminErrorBoundry_1 = __importDefault(require("../common/ReactAdmin/ReactAdminErrorBoundry"));
var PlayersListBase_1 = __importDefault(require("./PlayersListBase"));
var react_admin_2 = require("react-admin");
var SortArrayContext_1 = require("./SortArrayContext");
var withSortArray = function (dataProvider, getSortArray) { return (__assign(__assign({}, dataProvider), { getList: function (resource, params) { return __awaiter(void 0, void 0, void 0, function () {
        var sortArray, newParams;
        return __generator(this, function (_a) {
            sortArray = getSortArray();
            newParams = __assign(__assign({}, params), { meta: __assign(__assign({}, params.meta), { sort: sortArray }) });
            return [2 /*return*/, dataProvider.getList(resource, newParams)];
        });
    }); } })); };
var dataProvider = (0, ra_data_simple_rest_1.default)("/api/list", react_admin_2.fetchUtils.fetchJson, "Content-Range");
var httpClient = react_admin_2.fetchUtils.fetchJson;
var twoAttrSortDataProvider = __assign(__assign({}, dataProvider), { getList: function (resource, params) { return __awaiter(void 0, void 0, void 0, function () {
        var pagination, meta, filter, sortArray, sortParam, page, perPage, rangeParam, filterParam, url, _a, json, headers, contentRange, total;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    pagination = params.pagination, meta = params.meta, filter = params.filter;
                    sortArray = (meta === null || meta === void 0 ? void 0 : meta.sort) || SortArrayContext_1.DEFAULT_PLAYERS_SORT_ARRAY;
                    sortParam = JSON.stringify(sortArray);
                    page = pagination.page, perPage = pagination.perPage;
                    rangeParam = JSON.stringify([(page - 1) * perPage, page * perPage - 1]);
                    filterParam = JSON.stringify(filter || {});
                    url = "/api/list/players?filter=".concat(encodeURIComponent(filterParam), "&range=").concat(encodeURIComponent(rangeParam), "&sort=").concat(encodeURIComponent(sortParam));
                    return [4 /*yield*/, httpClient(url)];
                case 1:
                    _a = _b.sent(), json = _a.json, headers = _a.headers;
                    contentRange = headers.get("Content-Range");
                    total = contentRange.split("/").pop();
                    return [2 /*return*/, {
                            data: json,
                            total: parseInt(total, 10),
                        }];
            }
        });
    }); } });
var store = (0, react_admin_1.localStorageStore)();
var PlayersComponent = function (props) {
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)("grid"), active = _a[0], setActive = _a[1];
    var _b = (0, react_1.useState)([]), playerGroups = _b[0], setPlayerGroups = _b[1];
    var _c = (0, react_1.useState)(false), connectPlayerModalShown = _c[0], setConnectPlayerModalShown = _c[1];
    var _d = (0, react_1.useState)(false), newGroupModalShown = _d[0], setNewGroupModalShown = _d[1];
    var _e = (0, react_1.useState)(false), newPlayerModalShown = _e[0], setNewPlayerModalShown = _e[1];
    var _f = (0, react_1.useState)(0), refreshKey = _f[0], setRefreshKey = _f[1];
    var sortArray = (0, SortArrayContext_1.useSortArray)().sortArray;
    var dataProvider = withSortArray(twoAttrSortDataProvider, function () { return sortArray; });
    var setView = function (newView) {
        try {
            setActive(newView);
            localStorage.setItem("activeView", newView);
        }
        catch (error) {
            logger.warn("Set players view: " + error.message, error);
        }
    };
    var toggleConnectPlayerModal = function () {
        setConnectPlayerModalShown(function (shown) { return !shown; });
    };
    var toggleNewGroupModal = function () {
        setNewGroupModalShown(function (shown) { return !shown; });
    };
    var toggleNewPlayerModal = function () {
        setNewPlayerModalShown(function (shown) { return !shown; });
    };
    var toggleConnectPlayer = function () {
        setNewPlayerModalShown(false);
        setConnectPlayerModalShown(true);
    };
    var getPlayerGroups = function () {
        ApiManager_1.default.getPlayerGroups()
            .then(function (response) {
            var responseData = Object.keys(response.data).map(function (key) { return response.data[key]; });
            setPlayerGroups(responseData);
        })
            .catch(function (error) {
            logger.error("Failed to fetch player groups: ", error);
        });
    };
    var refreshPlayerGroups = function () {
        getPlayerGroups();
        setRefreshKey(function (prevKey) { return prevKey + 1; });
    };
    var handlePlayerGroupsDeletion = function (updatedPlayerGroups) {
        setPlayerGroups(updatedPlayerGroups);
    };
    (0, react_1.useEffect)(function () {
        var savedView = localStorage.getItem("activeView");
        if (savedView) {
            setActive(savedView);
        }
        getPlayerGroups();
        var handleEvent = function () {
            refreshPlayerGroups();
        };
        window.addEventListener("player-created", handleEvent);
        return function () {
            window.removeEventListener("player-created", handleEvent);
        };
    }, []);
    return (react_1.default.createElement("div", { className: Players_module_css_1.default.content_container },
        react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-end mb-5" },
            react_1.default.createElement("div", { className: Players_module_css_1.default.player_actions },
                react_1.default.createElement(AccessControl_1.default, { requiredPermissions: "global-players-manager" },
                    react_1.default.createElement(q_play_components_1.Button, { text: t("New Group"), variant: "secondary", size: "small", style: { width: "122px" }, onClick: toggleNewGroupModal, dataCy: "playersNewGroupModal" })),
                react_1.default.createElement(AccessControl_1.default, { optionalPermissions: ["global-players-manager", "resource-group-manager"], resourceType: "playerGroups" },
                    react_1.default.createElement(q_play_components_1.Button, { text: t("New Player"), variant: "secondary", size: "small", style: { width: "122px", marginLeft: "28px" }, dataCy: "newPlayerModalButton", onClick: toggleNewPlayerModal }),
                    react_1.default.createElement(q_play_components_1.Button, { text: t("Connect Player"), size: "small", style: { width: "122px", marginLeft: "28px" }, onClick: toggleConnectPlayerModal, dataCy: "connectPlayerModalButton" }))),
            react_1.default.createElement("div", { className: "d-flex" },
                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", onClick: function () { return setView("grid"); }, style: {
                        width: "42px",
                        height: "37px",
                        background: "var(--bs-body-bg)",
                    }, className: active == "grid"
                        ? "opacity-100 d-flex align-items-center justify-content-center"
                        : "opacity-50 d-flex align-items-center justify-content-center" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGrid2, style: { fontSize: "28px" }, color: "var(--info-color)" })),
                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", onClick: function () { return setView("list"); }, style: {
                        width: "42px",
                        height: "37px",
                        background: "var(--bs-body-bg)",
                        marginLeft: "17px",
                    }, className: active == "list"
                        ? "opacity-100 d-flex align-items-center justify-content-center"
                        : "opacity-50 d-flex align-items-center justify-content-center" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faList, style: { fontSize: "28px" }, color: "var(--info-color)" })),
                react_1.default.createElement(AccessControl_1.default, { requiredPermissions: ["sys-admin"] },
                    react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", onClick: function () { return setActive("overview"); }, style: {
                            width: "42px",
                            height: "37px",
                            background: "var(--bs-body-bg)",
                            marginLeft: "17px",
                        }, className: active == "overview"
                            ? "opacity-100 d-flex align-items-center justify-content-center"
                            : "opacity-50 d-flex align-items-center justify-content-center" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEye, style: { fontSize: "28px" }, color: "var(--info-color)" }))))),
        react_1.default.createElement(react_admin_1.AdminContext, { dataProvider: dataProvider, store: store },
            react_1.default.createElement(ReactAdminErrorBoundry_1.default, { resourceName: "players", resourceURL: "/players" },
                react_1.default.createElement(react_admin_1.ResourceContextProvider, { value: "players" },
                    react_1.default.createElement(react_admin_1.I18nContextProvider, { value: react_admin_1.defaultI18nProvider },
                        active === "grid" ? (react_1.default.createElement(PlayersGridView_1.default, { key: refreshKey, playerGroups: playerGroups, handlePlayerGroupsDeletion: handlePlayerGroupsDeletion, refreshPlayerGroups: refreshPlayerGroups, permissions: props.permissions })) : active === "list" || active === "overview" ? (react_1.default.createElement(PlayersListBase_1.default, { key: refreshKey, playerGroups: playerGroups, refreshPlayerGroups: refreshPlayerGroups, permissions: props.permissions, activeView: active })) : null,
                        react_1.default.createElement(NewPlayerGroupModal_1.default, { isShown: newGroupModalShown, toggle: toggleNewGroupModal, getPlayerGroups: getPlayerGroups }),
                        react_1.default.createElement(NewPlayerModal_1.default, { isShown: newPlayerModalShown, toggle: toggleNewPlayerModal, toggleConnectPlayer: toggleConnectPlayer }),
                        react_1.default.createElement(ConnectPlayerModal_1.default, { isShown: connectPlayerModalShown, toggle: toggleConnectPlayerModal })))))));
};
exports.default = PlayersComponent;
